import { render, staticRenderFns } from "./WriteDefaultInfoForm.vue?vue&type=template&id=a1731dca&scoped=true&"
import script from "./WriteDefaultInfoForm.vue?vue&type=script&lang=js&"
export * from "./WriteDefaultInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./WriteDefaultInfoForm.vue?vue&type=style&index=0&id=a1731dca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1731dca",
  null
  
)

export default component.exports